import React, { useCallback, useState } from "react"
import { FaRegStar, FaStar } from "react-icons/fa"
import _map from "lodash/map"
import { COLORS } from "../constants/colors"
import Loader from "./Loader"
import { addUserBookingFeedback } from "../api/common"

const RATINGS = [1, 2, 3, 4, 5]

const RateExperience = ({
  showRateExperience,
  hideRateExperienceModal,
  bookingkey,
  spaceName,
  customerName,
  spaceId,
}) => {
  const [rating, setRating] = useState(1)
  const [feedbackComments, setFeedbackComments] = useState("")
  const [savingRating, setSavingRating] = useState(false)

  const hideModal = () => {
    setFeedbackComments("")
    setRating(1)
    hideRateExperienceModal()
  }

  const onSaveRatingPress = useCallback(async () => {
    setSavingRating(true)
    try {
      const response = await addUserBookingFeedback({
        rating,
        commentForSpaces: feedbackComments,
        bookingId: bookingkey,
        spaceName,
        spaceId,
        customerName,
      })

      setSavingRating(false)
      hideModal()
      if (response) alert("Thank you for providing your feedback")
      else alert("Error saving rating. Please try again")
    } catch {
      setSavingRating(false)
      alert("Error saving rating. Please try again")
    }
  }, [rating, feedbackComments, bookingkey, spaceName, spaceId, customerName])

  if (!showRateExperience) return null
  return (
    <div
      className="modal fade show bd-example-modal-sm"
      id="selectCity"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="selectCity"
      aria-hidden="true"
      style={{ display: "block" }}
    >
      <div
        className="modal-dialog modal-sm"
        role="document"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div
          className="modal-content"
          style={{ background: "#fff", maxWidth: 320 }}
        >
          <div className="modal-body">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={hideModal}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="bold mb-2">Tell us how we did</p>
          </div>
          <div style={{ padding: "0 15px", width: "100%" }}>
            <p>Rating</p>
            <div className="d-flex align-items-center">
              {_map(RATINGS, ratingNumber => {
                if (ratingNumber <= rating)
                  return (
                    <FaStar
                      style={{
                        color: COLORS.STAR_RATING,
                        width: 24,
                        height: 24,
                      }}
                      onClick={() => setRating(ratingNumber)}
                    />
                  )
                return (
                  <FaRegStar
                    style={{ width: 24, height: 24 }}
                    onClick={() => setRating(ratingNumber)}
                  />
                )
              })}
            </div>
            <p style={{ padding: "16px 0 8px" }}>Feedback</p>
            <textarea
              value={feedbackComments}
              onChange={e => {
                setFeedbackComments(e.currentTarget.value)
              }}
              rows={4}
              style={{
                width: "100%",
                padding: 8,
                borderRadius: 8,
                marginBottom: 16,
                border: `1px solid ${COLORS.TEXT_COLOR_SECONDARY}`,
              }}
            />
            {savingRating ? (
              <div
                className="d-flex justify-content-center"
                style={{ width: "100%" }}
              >
                <Loader />
              </div>
            ) : (
              <button
                onClick={onSaveRatingPress}
                className="py-2"
                style={{
                  width: "100%",
                  backgroundColor: "#2798B5",
                  alignItems: "center",
                  border: "none",
                  borderRadius: 4,
                  color: "white",
                  marginBottom: 16,
                }}
              >
                Save
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default RateExperience
